module.exports = __webpack_public_path__ + "media/images/edit-icon-4da657b2172c827c94e5422d569a5bc2.svg";